module.exports = {"320213021":"崇安寺街道","320213022":"清名桥街道","320213023":"惠山街道","320213024":"北大街街道","320213025":"广益街道","320213026":"扬名街道","320213027":"山北街道","320213028":"黄巷街道","320213029":"瞻江街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320213.json
// module id = 942
// module chunks = 0